import DownloadIcon from "@mui/icons-material/Download";
import { Button, CircularProgress } from "@mui/material";
import { ButtonProps } from "@mui/material/Button";
import { useDownloadFiles } from "hooks/useDownloadFiles";

interface JobDownloadButtonProps extends Omit<ButtonProps, "onClick"> {
  downloadKeys: string[];
}

export function JobDownloadButton({ downloadKeys, ...buttonProps }: JobDownloadButtonProps) {
  const { download, busy } = useDownloadFiles();

  return (
    <Button
      startIcon={busy ? <CircularProgress size={20} /> : <DownloadIcon />}
      variant="outlined"
      onClick={() => download(downloadKeys)}
      disabled={busy}
      {...buttonProps}
    >
      {busy ? "Downloading…" : "Download Output Files"}
    </Button>
  );
}
